import React from 'react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { TableComponent, connect } from './tableComponent';
import Sublogin from './elements/sublogin';
import { getSid } from 'src/helpers/session';

var defaultEarnings = 10;

const newAgent = {
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  earnings: defaultEarnings
};

class Component extends TableComponent {
  initialState = {
    from: moment().isoWeekday(1),
    to: moment().add(1, 'day')
  };

  state = {
    user: newAgent,
    modalOpen: false,
    error: ''
  };

  componentDidMount() {
    if (this.props.user.id == 1915) {
      this.state.user.earnings = newAgent.earnings = defaultEarnings = 1;
    }
  }

  getCellValue = (prefix, { original: data }) => {
    let sales = parseInt(data[prefix + '_sales']) || 0;
    let trials = parseInt(data[prefix + '_trials']) || 0;
    let earnings = data[prefix + '_dollars'] || 0;
    let visits = parseInt(data[prefix + '_visits']) || 0;
    let unique = parseInt(data[prefix + '_unique']) || 0;
    let showVisits = this.props.user.autologin == 1;
    return (
      <div>
        <div>
          {sales > 0 && sales + ' sales / '}
          {trials > 0 && trials + ' leads / '}
          {earnings > 0 && '$ ' + earnings}
          {sales == 0 && trials == 0 && earnings == 0 && unique == 0 && '0 / 0'}
        </div>
        <div>
          {unique > 0 && unique + ' unique'}
          {showVisits && visits > 0 && ' / ' + visits + ' visits'}
        </div>
      </div>
    );
  };

  getFooterValue = (prefix, props) => {
    let data = this.props.total;
    let sales = data[prefix + '_sales'] || 0;
    let trials = data[prefix + '_trials'] || 0;
    let earnings = data[prefix + '_dollars'] || 0;
    let visits = data[prefix + '_visits'] || 0;
    let unique = data[prefix + '_unique'] || 0;
    let showVisits = this.props.user.autologin == 1;
    return (
      <div>
        <div>
          {sales > 0 && sales + ' sales / '}
          {trials > 0 && trials + ' leads / '}
          {earnings > 0 && '$ ' + earnings}
        </div>
        <div>{showVisits && visits > 0 && visits + ' visits'}</div>
        <div>{unique > 0 && unique + ' unique'}</div>
      </div>
    );
  };

  makeColumns = () => {
    const columns = [
      {
        Header: 'Wid',
        accessor: 'aid',
        minWidth: 60,
        Footer: (props) => <span>Total</span>
      },
      {
        Header: 'Earning',
        accessor: 'chatsales_earnings',
        minWidth: 60,
        Cell: (props) => (
          <input
            class='form-control form-control-sm'
            type='number'
            value={props.original.chatsales_earnings}
            onChange={(e) => {
              this.handleChangeData(e.target.value, props);
            }}
            onBlur={(e) => {
              this.handleSubmitData(props);
            }}
          />
        ),
        Footer: (props) => <span>{this.props.total.count || 0}</span>
      },
      {
        Header: 'Name',
        accessor: 'firstname',
        minWidth: 150,
        Cell: (props) => <span>{props.original.firstname + ' ' + props.original.lastname}</span>
      },
      {
        Header: 'Email',
        accessor: 'email',
        minWidth: 150
      },
      {
        Header: 'Today',
        accessor: 'today_sales',
        minWidth: 120,
        Cell: (props) => this.getCellValue('today', props),
        Footer: (props) => this.getFooterValue('today', props)
      },
      {
        Header: 'Yesterday',
        accessor: 'yesterday_sales',
        minWidth: 120,
        Cell: (props) => this.getCellValue('yesterday', props),
        Footer: (props) => this.getFooterValue('yesterday', props)
      },
      {
        Header: 'Last week',
        accessor: 'week_sales',
        minWidth: 120,
        Cell: (props) => this.getCellValue('week', props),
        Footer: (props) => this.getFooterValue('week', props)
      },
      {
        Header: (props) =>
          this.props.state.from.format('D MMM') + ' - ' + this.props.state.to.format('D MMM'),
        accessor: 'between_sales',
        minWidth: 130,
        Cell: (props) => this.getCellValue('between', props),
        Footer: (props) => this.getFooterValue('between', props)
      },
      {
        Header: '',
        accessor: 'aid',
        id: 'login',
        sortable: false,
        minWidth: 70,
        Cell: (props) => <Sublogin aid={props.value} class='' />
      }
    ];
    return columns;
  };

  apiPath = 'affiliate/agents';
  editApiPath = 'affiliate/agent_edit';

  tableParams = {
    manual: true,
    sorted: [
      {
        id: 'aid',
        desc: true
      }
    ]
  };

  openModal = (e) => {
    this.setState({ modalOpen: true });
  };

  createAgent = (e) => {
    e.preventDefault();
    let stateUser = this.state.user;
    let agent = {
      firstname: stateUser.firstname,
      lastname: stateUser.lastname || '',
      email: stateUser.email,
      password: stateUser.password,
      earnings: stateUser.earnings
    };
    if (!agent.firstname || !agent.email || !agent.password || this.state.loading) return;
    this.setState({ error: '', loading: true });
    this.props.api('affiliate/agent_create', agent).then((res) => {
      console.log('affiliate/agent_create res:', res);
      if (res && res.result) {
        this.setState({
          modalOpen: false,
          user: {
            firstname: '',
            lastname: '',
            email: '',
            password: '',
            earnings: defaultEarnings
          },
          loading: false
        });
        this.fetchData({ forceReload: true });
      } else {
        this.setState({
          error: res && res.error ? res.error.toString() : 'Server error',
          loading: false
        });
      }
    });
  };

  handleModalInputChange = (event) => {
    const target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    value = target.type === 'file' ? target.files[0] : value;
    let user = this.state.user;
    user[target.name] = value;
    this.setState({ user });
  };

  renderModal() {
    // if (!this.state.user) return;
    return (
      <div>
        <form
          class={'modal fade black-overlay ' + (this.state.modalOpen ? 'show d-block' : '')}
          onSubmit={this.createAgent}
        >
          <div class='modal-dialog'>
            <div class='modal-content'>
              <div class='modal-header'>
                <h5 class='modal-title'>{this.state.user.aid ? 'Edit agent' : 'Add agent'}</h5>
              </div>
              <div class='modal-body'>
                <div class='form-group row'>
                  <label class='col-sm-2 col-form-label'>Email</label>
                  <div class='col-sm-10'>
                    <input
                      type='email'
                      class='form-control'
                      placeholder='Email'
                      name='email'
                      required
                      value={this.state.user.email}
                      onChange={this.handleModalInputChange}
                    />
                  </div>
                </div>
                <div class='form-group row'>
                  <label class='col-sm-2 col-form-label'>Password</label>
                  <div class='col-sm-10'>
                    <input
                      type='password'
                      class='form-control'
                      placeholder='Password'
                      name='password'
                      required
                      value={this.state.user.password}
                      onChange={this.handleModalInputChange}
                    />
                  </div>
                </div>
                <div class='form-group row'>
                  <label class='col-sm-2 col-form-label'>Firstname</label>
                  <div class='col-sm-10'>
                    <input
                      type='text'
                      class='form-control'
                      placeholder='Firstname'
                      name='firstname'
                      required
                      value={this.state.user.firstname}
                      onChange={this.handleModalInputChange}
                    />
                  </div>
                </div>
                <div class='form-group row'>
                  <label class='col-sm-2 col-form-label'>Lastname</label>
                  <div class='col-sm-10'>
                    <input
                      type='text'
                      class='form-control'
                      placeholder='Lastname'
                      name='lastname'
                      value={this.state.user.lastname}
                      onChange={this.handleModalInputChange}
                    />
                  </div>
                </div>
                <div class='form-group row'>
                  <label class='col-sm-2 col-form-label'>Earnings</label>
                  <div class='col-sm-10'>
                    <input
                      type='number'
                      class='form-control'
                      placeholder='Earnings'
                      name='earnings'
                      value={this.state.user.earnings}
                      onChange={this.handleModalInputChange}
                    />
                  </div>
                </div>
                <div>{this.state.error}</div>
              </div>
              <div class='modal-footer'>
                <button
                  type='button'
                  class='btn warning'
                  onClick={(e) => this.setState({ modalOpen: false })}
                >
                  Cancel
                </button>
                <button type='submit' class='btn primary'>
                  Add
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }

  render() {
    let link = location.protocol + '//' + location.host + '/app?oid=' + this.props.user.aid;
    var searchFrom = '';
    var searchTo = '';
    if (this.props.state.from && this.props.state.to) {
      searchFrom = this.props.state.from.format('DD-MM-YYYY');
      searchTo = this.props.state.to.format('DD-MM-YYYY');
    }
    let agentsEnabled = this.props.user.agents_enabled == 1;
    // agentsEnabled = true;
    return (
      <div class='co__pg-agents'>
        {this.renderModal()}
        <div class='row'>
          <div class='col-sm col-sm-10 text-center co__table-filters'>
            <div class='pull-left mr-2'>{this.datepickerElement()}</div>
            {agentsEnabled && (
              <button class='btn btn-sm success pull-left' onClick={this.openModal}>
                Add agent
              </button>
            )}
            <a
              href={
                '/app/api/affiliate/agents_export?sid=' +
                getSid() +
                '&from=' +
                searchFrom +
                '&to=' +
                searchTo
              }
              class='ml-2 pull-left'
            >
              <button class='btn btn-sm primary'>CSV</button>
            </a>
            {agentsEnabled && (
              <React.Fragment>
                <span class='pull-left p-2'>Invite agent:</span>
                <CopyToClipboard text={link} onCopy={() => this.setState({ copied: link })}>
                  <button class='btn primary pull-right'>
                    {this.state.copied == link ? 'Copied' : 'Copy'}
                  </button>
                </CopyToClipboard>
                <pre class='overflow-hidden p-2 m-0'>{link}</pre>
              </React.Fragment>
            )}
          </div>
          <div class='col-sm col-sm-2'>{this.searchElement()}</div>
        </div>
        <div class='row'>
          <div class='col-sm-12'>
            <div class='box mt-2'>{this.reactTable()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component, 'affiliate_agents', function (state) {
  return {
    apiChangeState: state.api.affiliate_agent_edit || state.api.initial
  };
});
